import React from "react";
import { Outlet, useParams, Navigate } from "react-router-dom";
import { I18nProvider, LANGS } from "@/i18n";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";

export default function LangLayout() {
  const { lang } = useParams();
  if (!LANGS.includes(lang)) {
    return <Navigate to="/ar" replace />;
  }
  return (
    <I18nProvider lang={lang}>
      <div className="min-h-screen flex flex-col bg-[color:var(--rv-bg)] text-[color:var(--rv-ink)]">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}
